import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { SettingsService } from '../../../shared/services/settings.service';
import { SettingsBaseComponent } from '../settings-base/settings-base.component';

@Component({
  selector: 'app-central-insolvency-register-settings',
  templateUrl: './central-insolvency-register-settings.component.html',
  styleUrls: ['./central-insolvency-register-settings.component.scss']
})
export class CentralInsolvencyRegisterSettingsComponent extends SettingsBaseComponent implements OnInit {

  constructor(protected formBuilder: FormBuilder, protected settingsService: SettingsService, protected toastrService: ToastrService, protected translateService: TranslateService) {
    super(formBuilder, settingsService, toastrService, translateService);
  }

  ngOnInit() {
  }
}